import React from "react"
import { connect } from "react-redux"
import CreatableSelect from "react-select/creatable"
import CustomClearIndicator from "./CustomClearIndicator"
import customStyles from "./style/customStyles"
import { selectRolesUpdate } from "../../redux/actions/project"
import getOptionsRoles from "../../redux/reselect/getOptionsRoles"

const SelectRoles = ({
  wId, // whereId
  name,
  value,
  optionsRoles,
  isDisabled = false,
  isLocked = false,
  dispatch,
}) => {
  //=================================================================
  const onChange = (data, actionMeta) => {
    // data.label has either the sId or - if new - the new name
    // select Id = sId has nId here

    let payload = {}

    if (actionMeta.action === "clear") {
      payload = { wId, name, selected: [], isNew: false }
    } else {
      payload = { wId, name, selected: data }
    }

    dispatch(selectRolesUpdate(payload))
  }
  //=================================================================
  return (
    <CreatableSelect
      name="requests"
      value={value}
      onChange={onChange}
      options={optionsRoles}
      styles={customStyles}
      isMulti
      isDisabled={isLocked}
      isLocked={isLocked}
      className="basic-multi-select"
      classNamePrefix="select"
      components={{
        ClearIndicator: CustomClearIndicator,
        DropdownIndicator: null,
        IndicatorSeparator: null,
        Placeholder: () => null,
      }}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    optionsRoles: getOptionsRoles(state),
  }
}

export default connect(mapStateToProps)(SelectRoles)
